export const appModes = {
    APP_MODE_NORMAL: 'normal',
    APP_MODE_HIDDEN: 'hidden',
};

export const applicationKeyPrefix = "uniportal.application.";

export const IS_DEV = process.env.NODE_ENV === 'development';
